export const NC_DEFAULT_GAME = { primary_color: "#2f6fe4", accent_color: "#f5b82e", bg_color: "#ffffff" };

export const isLightHex = (hex) => {
  const h = (hex || "").replace("#", "");
  if (h.length < 6) return true;
  const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
  return 0.299 * r + 0.587 * g + 0.114 * b > 150;
};

export const themeClass = (bg, forceDark = false) => (!forceDark && isLightHex(bg) ? "lp-light" : "lp-dark");
